import CrmApi from '../../api/crm';

export const actions = {
  sendData: async function sendDataToCrm(
    { commit },
    {
      accountId,
      token,
      filterResponseTime = {},
      filterNewLeads = {},
      filterContactsPerChannel = {},
      filterScheduleOccupations = {},
    } = {}
  ) {
    try {
      const response = await CrmApi.sendData({
        accountId,
        token,
        filterResponseTime,
        filterNewLeads,
        filterContactsPerChannel,
        filterScheduleOccupations,
      });
      return response;
    } catch (error) {
      // Ignore error
    }
  },
};

export default {
  namespaced: true,
  actions,
};
